import { ThemeConfig } from '@src/types';

export const getThemeURL = (
  res: ThemeConfig | undefined,
  partnername: string | undefined,
  type: 'ui' | 'i18n' | 'auth-flow' | 'icons',
  configType: 'theme-url' | 'texts-url' | 'auth-url' | 'icons-url'
) => {
  if (res && res[configType] && partnername) {
    return `/${String(partnername)}/${type}/${String(res[configType])}.json`;
  }

  return '';
};
